import { render, staticRenderFns } from "./SplitPaymentView.vue?vue&type=template&id=6749f4a0&scoped=true"
import script from "./SplitPaymentView.vue?vue&type=script&lang=js"
export * from "./SplitPaymentView.vue?vue&type=script&lang=js"
import style0 from "./SplitPaymentView.vue?vue&type=style&index=0&id=6749f4a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6749f4a0",
  null
  
)

export default component.exports